import { useCallback } from 'react'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import API from "@api/api";
import { useState } from 'react'

export default function usePickedImageDownload(projectId, projectName) {
    const [downLoading, setDownLoading] = useState(false)
    function sanitizeFileName(name = '') {
        return name
            .replace(/[\\/:*?"<>|]/g, '_') // Windows 不允许的字符
            .replace(/\s+/g, '_')          // 空格替换为下划线
            .replace(/[^\w.-]/g, '_')      // 其余非字母数字点或横线的字符也替换掉
            .slice(0, 100)                 // 限制长度，避免路径过长
    }


    const handleDownload = useCallback(async () => {
        if (!projectId) {
            console.warn('缺少 projectId，无法下载')
            return
        }

        try {
            const res = await API.getPickedImageList({
                projectId,
                picked: true,
            })

            if (res.code !== 0 || !res.data?.length) {
                console.warn('没有可下载的图片')
                return
            }
            setDownLoading(true)

            const pickedList = res.data
            const zip = new JSZip()

            // 相同 skuId 放入同一组
            const grouped = pickedList.reduce((acc, item) => {
                const skuId = item.skuId
                if (!acc[skuId]) acc[skuId] = []
                acc[skuId].push(item)
                return acc
            }, {})

            const skuIds = Object.keys(grouped)
            let index = 0

            // 遍历每组进行下载
            for (const skuId of skuIds) {
                const group = grouped[skuId]
                const folderName = `${sanitizeFileName(group[0]?.skuName || 'unknown')}_${sanitizeFileName(group[0]?.skuSerial || skuId)}`
                const skuFolder = zip.folder(folderName)

                for (let i = 0; i < group.length; i++) {
                    const url = group[i].result
                    if (!url) continue

                    try {
                        const response = await fetch(url)
                        const blob = await response.blob()
                        const ext = url.split('.').pop().split('?')[0]
                        skuFolder.file(`${i + 1}.${ext}`, blob)
                    } catch (err) {
                        console.error('图片下载失败:', url, err)
                    }

                    index++
                }
            }
            const getProjectName = await API.batchListSkuCoverList({ projectId: projectId })
            const projectName = getProjectName?.data?.projectName || ''
            const zipBlob = await zip.generateAsync({ type: 'blob' })
            saveAs(zipBlob, `PSAI_${projectName}.zip`)
            console.log('下载完成')
            setDownLoading(false)

        } catch (error) {
            console.error('下载失败:', error)
            setDownLoading(false)
        }
    }, [projectId, projectName])

    return { handleDownload, downLoading }
}
